/* eslint-disable */
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
//import * as serviceWorker from './serviceWorker';
import App from './App';
import UserProvider from './providers/UserProvider';

ReactDOM.render((
  <BrowserRouter>
    <UserProvider>
      <App />
    </UserProvider>
  </BrowserRouter>
), document.getElementById('root'));

//serviceWorker.unregister();
